/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramUsersControllerCreateTelegramLinkMutationResponse,
  TelegramUsersControllerCreateTelegramLink401,
} from '../../types/TelegramUsersControllerCreateTelegramLink.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramUsersCreateTelegramLink } from '../../methods/telegramUsersCreateTelegramLink.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramUsersCreateTelegramLinkMutationKey = () => [{ url: '/api/telegram/users/telegram-link' }] as const;

export type TelegramUsersCreateTelegramLinkMutationKey = ReturnType<typeof telegramUsersCreateTelegramLinkMutationKey>;

/**
 * {@link /api/telegram/users/telegram-link}
 */
export function useTelegramUsersCreateTelegramLink<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramUsersControllerCreateTelegramLinkMutationResponse,
      ResponseErrorConfig<TelegramUsersControllerCreateTelegramLink401>,
      void,
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramUsersCreateTelegramLinkMutationKey();

  return useMutation<
    TelegramUsersControllerCreateTelegramLinkMutationResponse,
    ResponseErrorConfig<TelegramUsersControllerCreateTelegramLink401>,
    void,
    TContext
  >(
    {
      mutationFn: async () => {
        return telegramUsersCreateTelegramLink(config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
